import { getMetaValue } from './utils'
import {
  enableGoogleAnalytics,
  enableFacebookPixel,
  enableHotjar,
  enableWisepops
} from './vendor/tracking'

// Listen for Plume cookie consent events
window.addEventListener('plume:cookie-consent-granted', function (event) {
  const preferences = event.detail.preferences

  if (preferences.analytics) {
    enableGoogleAnalytics()
    enableHotjar()
  }

  if (preferences.marketing) {
    enableFacebookPixel()
    enableWisepops()
  }
})

// Check if consent was already granted (on page load)
document.addEventListener('DOMContentLoaded', function () {
  if (window.PlumeCookies && window.PlumeCookies.hasConsent()) {
    const preferences = window.PlumeCookies.getPreferences()

    if (preferences.analytics) {
      enableGoogleAnalytics()
      enableHotjar()
    }

    if (preferences.marketing) {
      enableFacebookPixel()
      enableWisepops()
    }
  }
})
